import React from "react";
import {
  Card,
  CardBody,
  Typography,
  Button
} from "@material-tailwind/react";
import { ArrowLongRightIcon, LightBulbIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

export default function CiberCticontent() {

 

  return (
    <>
      <div className="w-full mx-auto inline-block md:w-3/4 md:flex-row ">

<nav
    className="w-11/12 mx-auto mt-6 mb-2 text-sm text-gray-500 lg:w-full"
    aria-label="Breadcrumb"
  >
    <Link
      to="/Servicios-Ciberseguridad"
      className="hover:text-indigo-600 transition font-medium"
    >
      Ciberseguridad
    </Link>
    <span className="mx-2">›</span>
    <span className="text-gray-800">
      Inteligencia — CTI
    </span>
  </nav>
       <div className="flex items-center gap-3 w-11/12 mx-auto mt-5 md:mt-0 lg:w-full mb-3">
                <LightBulbIcon className="text-indigo-500 w-10 h-10 group-hover:text-white" />
        <Typography
           variant="h3"
           className="text-black font-sanz text-left"
         >
           
        Inteligencia — CTI (Cyber Threat Intelligence)
        </Typography>
          </div>
       
        <Typography
          className="w-11/12 mx-auto md:mt-0 text-left lg:w-full font-mono text-xl"
        >Generamos inteligencia accionable mediante el monitoreo permanente de tu superficie digital, incluyendo fuentes abiertas, deep web y dark web. Detectamos filtraciones, amenazas emergentes y riesgos dirigidos a tu marca, a tus ejecutivos y a tus activos críticos.<br/>
        <br/>A través de honeynets y fuentes especializadas, recopilamos y enriquecemos indicadores para integrarlos en tus plataformas de seguridad, permitiendo anticiparte a actores maliciosos y tomar decisiones informadas antes de que un ataque afecte tu operación.
        </Typography>
        <div className="flex flex-wrap justify-center gap-3 mt-10 md:justify-around">

         <Typography
          variant="h3"
          className="w-11/12 mx-auto mt-5 md:mt-0 lg:w-full mb-3 text-black font-sanz text-left"
        >Servicio de monitoreo
        </Typography>

        
<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Threat Actor Track
                </Typography>
                <Typography className="group-hover:text-white">
                 Monitoreo continuo de grupos de amenazas para identificar TTPs (Tácticas, Técnicas y Procedimientos), campañas activas y patrones de comportamiento.
                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Tracking de grupos APT y hacktivistas
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Análisis de campañas de ataque
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Perfilamiento de comportamiento
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Alertas tempranas de actividad
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Dark Web / Deep Web Monitor
                </Typography>
                <Typography className="group-hover:text-white">
                 Vigilancia en foros y marketplaces cerrados para identificar datos filtrados y actividad maliciosa relevante.
                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Monitoreo de datos corporativos filtrados
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Detección de credenciales comprometidas
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Alertas de planes de ataque
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Análisis de reputación digital
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Data Leakage Monitor
                </Typography>
                <Typography className="group-hover:text-white">
                 Detección temprana de fugas de información confidencial en fuentes públicas y restringidas.
                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Monitoreo de bases filtradas
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Detección de documentos sensibles
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Alertas de exposición de datos
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Análisis de impacto
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Credential Stuffing Monitor
                </Typography>
                <Typography className="group-hover:text-white">
                 Detección y prevención de intentos masivos de acceso usando credenciales comprometidas en otras brechas.
                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Identificación de patrones de ataque
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Monitoreo de listas de credenciales
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Alertas de intentos de acceso
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Protección proactiva de cuentas
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

<Typography
          variant="h3"
          className="w-11/12 mx-auto mt-5 md:mt-0 lg:w-full mb-3 text-black font-sanz text-left"
        >Servicio de análisis
        </Typography>
<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Threat Intelligence
                </Typography>
                <Typography className="group-hover:text-white">
                 Recolección y análisis de información sobre amenazas para generar inteligencia accionable que apoye la toma de decisiones.
                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Inteligencia estratégica y táctica
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Análisis de tendencias de amenazas
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Reportes personalizados
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Recomendaciones de mitigación
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Honeynet
                </Typography>
                <Typography className="group-hover:text-white">
                 Implementación de redes señuelo para recolectar IOCs (Indicators of Compromise), TTPs y muestras de malware en un entorno controlado.
                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Recolección de IOCs en tiempo real
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Análisis de TTPs y vectores de ataque
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Captura de malware
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Investigación de campañas activas
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Threat Feed / IOCs Management
                </Typography>
                <Typography className="group-hover:text-white">
                 Gestión centralizada y enriquecida de fuentes de inteligencia de amenazas e IOCs.
                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Agregación de múltiples feeds de amenazas
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Validación y scoring de IOCs
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Integración con SIEM/SOAR
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Soporte para STIX/TAXII
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  SIEM / SOAR Enrichment
                </Typography>
                <Typography className="group-hover:text-white">
                 Enriquecimiento de eventos con contexto de inteligencia para mejorar la detección y automatizar respuestas.
                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Contextualización de alertas
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Automatización de investigaciones
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Playbooks de respuesta
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Reducción de falsos positivos
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Infostealers Credentials
                </Typography>
                <Typography className="group-hover:text-white">
                 Análisis de malware infostealer para identificar credenciales comprometidas y campañas activas.
                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Análisis de malware infostealer
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Recuperación de credenciales robadas
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Tracking de campañas
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Mitigación de infecciones
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Malware Analysis
                </Typography>
                <Typography className="group-hover:text-white">
                 Análisis técnico profundo de muestras de malware para entender su funcionamiento, persistencia, comunicación C2 y generar contramedidas efectivas.
                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Análisis estático y dinámico
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Reversing de código malicioso
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Identificación de IOCs
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Desarrollo de contramedidas
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

<Typography
          variant="h3"
          className="w-11/12 mx-auto mt-5 md:mt-0 lg:w-full mb-3 text-black font-sanz text-left"
        >Servicio de protección
        </Typography>
<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  VIP Protection
                </Typography>
                <Typography className="group-hover:text-white">
                 Protección digital personalizada para ejecutivos y perfiles de alto riesgo frente a ataques dirigidos y exposición no deseada.
                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Protección contra doxing y extorsión
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Monitoreo de huella digital
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Seguridad de dispositivos personales
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Respuesta rápida a incidentes
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>

<Card className="mt-30 w-full">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                {/* <ClipboardDocumentListIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" /> */}
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Brand Protection / Reputation
                </Typography>
                <Typography className="group-hover:text-white">
                 Protección de la identidad y reputación corporativa frente a suplantación, fraudes y amenazas digitales.Protección de la identidad y reputación corporativa frente a suplantación, fraudes y amenazas digitales.
                <ul className="grid grid-cols-3 gap-2 mt-2 text-left">
  <li className="flex items-start gap-2">
    <span>•</span> Detección de sitios de phishing
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Protección contra falsificación
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Monitoreo de reputación online
  </li>
  <li className="flex items-start gap-2">
    <span>•</span> Gestión de crisis digitales
  </li>
</ul>
                </Typography>
              </CardBody>
              {/* <CardFooter className="pt-0">
                <Link to="/Contact/#form" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conoce más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter> */}
            </div>
          </Card>


<div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
                <button>
<Link to="/Contact/#form" className="inline-block ">
                                    <Button onClick={() => { localStorage.setItem("ESP", "CIB"); localStorage.setItem("SER", "ETC") }} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                                        Solicitar este servicio
                                        <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                                    </Button>
                                </Link>
                                </button>
         
          </div>
         
        </div>
      </div>
    </>
  );
}